var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("bimini-default-section", {
    staticClass: "menu--section-bimini_steak",
    class: { "menu--section-wagyu": _vm.isWagyuSection },
    attrs: {
      section: _vm.section,
      menu: _vm.menu,
      "menu-item-component": "bimini-steak-item",
      "section-modifier": "steak",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }